import { useEffect, useState } from 'react';

const calulateTotal = (values: number[]) => {
  return values.reduce((prev, current) => prev + current, 0);
};

const useRepaymentStrategyTotal = (repaymentValuesMap: Array<[boolean, number]>) => {
  const [values, setValues] = useState<number>(0);
  useEffect(() => {
    const repaymentValuesAdjustedToSectionVisibility = repaymentValuesMap.map(([isOn, value]) => {
      return isOn ? value : 0;
    });

    setValues(calulateTotal(repaymentValuesAdjustedToSectionVisibility));
  }, [repaymentValuesMap]);

  return values;
};

export default useRepaymentStrategyTotal;
